import { DrinkFrequency } from "@dcc/types/drinkFrequency";
import { BingeFrequency } from "@dcc/types/bingeFrequency";
import {
  AUDITC_BAND0_LIMIT,
  AUDITC_BAND1_LIMIT,
  AUDITC_BAND2_LIMIT,
  AUDITC_BAND3_LIMIT
} from "@dcc/constants/auditCConstants";

export const getDailyUnitScore = (totalDailyUnits: number) => {
  if (totalDailyUnits <= AUDITC_BAND0_LIMIT) {
    return 0;
  } else if (totalDailyUnits <= AUDITC_BAND1_LIMIT) {
    return 1;
  } else if (totalDailyUnits <= AUDITC_BAND2_LIMIT) {
    return 2;
  } else if (totalDailyUnits <= AUDITC_BAND3_LIMIT) {
    return 3;
  } else {
    return 4;
  }
};

export const getAuditCScore = ({
  drinkFrequency,
  bingeFrequency,
  dailyUnitScore
}: {
  drinkFrequency: DrinkFrequency;
  bingeFrequency: BingeFrequency;
  dailyUnitScore: number;
}) => bingeFrequency + dailyUnitScore + drinkFrequency;
